export const finishesById = {
    // WPC
    wpc_wood: {
        name: "WPC - Wood",
        imageUrl: "/assets/furnishing_icons/WPC-WOOD.webp",
    },
    wpc_dark_grey: {
        name: "WPC - Dark Grey",
        imageUrl: "/assets/furnishing_icons/WPC-DARKGREY.webp",
    },
    wpc_white: {
        name: "WPC - White",
        imageUrl: "/assets/furnishing_icons/WPC-WHITE.webp",
    },
    wpc_copper_brown: {
        name: "WPC - Copper brown",
        imageUrl: "/assets/furnishing_icons/WPC-COPPER-BROWN.webp",
    },

    // Metallo (per exte, cover, e generico)
    ral_9006: {
        name: "Ral 9006",
    },
    ral_custom: {
        name: "Ral custom",
    },

    // Acciaio inox (generico)
    acciaio_inox_default: {
        name: "Acciaio inox default"
    },

    // Pergodomino plastica
    pl_bianco: {
        name: "Bianco",
    },
    pl_grigio_perla: {
        name: "Grigio perla",
    },
    pl_grigio_platino: {
        name: "Grigio platino",
    },
    pl_antracite: {
        name: "Antracite",
    },
    pl_tortora: {
        name: "Tortora",
    },

    // Domino Lights (alluminio)
    al_black: {
        name: "Black - RAL 9005",
        imageUrl:
            "/assets/furnishing_icons/BLACK-RAL9005.webp",
    },
    al_silver: {
        name: "Silver - RAL 7046",
        imageUrl:
            "/assets/furnishing_icons/SILVER-RAL7046.webp",
    },
};

export const defaultFinishByMaterial = {
    wpc: "wpc_wood",
    metallo: "ral_custom",
    plastica: "pl_bianco",
    alluminio: "al_black",
    acciaio_inox: "acciaio_inox_default"
};